var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ClickAwayListener, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { BubbleChatIcon, Delete02Icon, Edit02Icon, InformationCircleIcon, MoreVerticalCircle01Icon } from 'hugeicons-react';
import { useEffect, useState } from 'react';
import useTranslate from '../../../../localization/helpers';
import AssetFolderIcon from '../../../icons/components/asset-folder-icon';
var SubFolderCard = function (_a) {
    var title = _a.title, docCount = _a.docCount, processedDocumentCount = _a.processedDocumentCount, processingDocumentCount = _a.processingDocumentCount, failedDocumentCount = _a.failedDocumentCount, unprocessableDocumentCount = _a.unprocessableDocumentCount, onClick = _a.onClick, onStartChat = _a.onStartChat, onViewClients = _a.onViewClients, onEditMachine = _a.onEditMachine, onDeleteMachine = _a.onDeleteMachine;
    var theme = useTheme();
    var translate = useTranslate().translate;
    var isXs = useMediaQuery(theme.breakpoints.down('sm'));
    var isIpadMini = useMediaQuery('(max-width: 768px)');
    var isIpadMiniLandscape = useMediaQuery('(min-width: 1024px) and (max-width: 1024px) and (orientation: landscape)');
    var _b = __read(useState(null), 2), openTooltipDocuments = _b[0], setOpenTooltipDocuments = _b[1];
    var _c = __read(useState(null), 2), anchorEl = _c[0], setAnchorEl = _c[1];
    useEffect(function () {
        var handleScroll = function (e) {
            var _a, _b;
            var t = e.target;
            if (((_a = t === null || t === void 0 ? void 0 : t.closest) === null || _a === void 0 ? void 0 : _a.call(t, '.MuiTooltip-popper')) || ((_b = t === null || t === void 0 ? void 0 : t.closest) === null || _b === void 0 ? void 0 : _b.call(t, '[data-tooltip-scrollable]'))) {
                return;
            }
            if (openTooltipDocuments !== null)
                setOpenTooltipDocuments(null);
        };
        window.addEventListener('scroll', handleScroll, true);
        return function () {
            window.removeEventListener('scroll', handleScroll, true);
        };
    }, [openTooltipDocuments]);
    var handleClickAway = function () {
        if (openTooltipDocuments !== null) {
            setOpenTooltipDocuments(null);
        }
    };
    var handleMenuOpen = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleMenuClose = function () {
        setAnchorEl(null);
    };
    var menuItems = [
        {
            text: translate('assets.startChat'),
            icon: BubbleChatIcon,
            onClick: function () { return onStartChat(); },
            color: undefined,
            divider: true,
            disabled: docCount === 0
        },
        {
            text: translate('assets.clientsAndSerials'),
            icon: InformationCircleIcon,
            onClick: onViewClients,
            color: undefined,
            divider: true,
            disabled: false
        },
        {
            text: translate('actions.edit'),
            icon: Edit02Icon,
            onClick: function () { return onEditMachine(); },
            color: undefined,
            divider: false
        },
        {
            text: translate('actions.delete'),
            icon: Delete02Icon,
            color: theme.palette.error.main,
            onClick: function () { return onDeleteMachine(); },
            divider: false
        }
    ];
    return (_jsxs(Box, { sx: {
            padding: isXs ? '10px 12px' : '16px 8px 16px 20px',
            gap: '4px',
            borderRadius: '16px',
            border: '1px solid rgba(145, 158, 171, 0.2)',
            cursor: 'pointer'
        }, children: [_jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsxs(Box, { display: 'flex', flexDirection: 'row', gap: 1.5, alignItems: 'center', sx: { flex: 1, minWidth: 0 }, onClick: onClick, children: [_jsx(AssetFolderIcon, { width: isXs ? 20 : 40, height: isXs ? 20 : 40 }), _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 0.5, sx: { flex: 1, minWidth: 0 }, children: [_jsx(Typography, { noWrap: true, fontWeight: 500, fontSize: 15, color: 'text.primary', children: title }), _jsx(ClickAwayListener, { onClickAway: handleClickAway, children: _jsx(Tooltip, { open: isXs || isIpadMini || isIpadMiniLandscape
                                                ? openTooltipDocuments === title
                                                : undefined, disableFocusListener: isXs || isIpadMini || isIpadMiniLandscape, disableTouchListener: isXs || isIpadMini || isIpadMiniLandscape, disableHoverListener: isXs || isIpadMini || isIpadMiniLandscape, title: _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 1, children: [_jsx(Box, { display: 'flex', gap: 1, children: _jsxs(Typography, { variant: 'caption', color: theme.palette.grey[400], children: [translate('common.processedDocuments'), ":", _jsxs(Typography, { variant: 'caption', color: theme.palette.common.white, children: ['', " ", processedDocumentCount] })] }) }), _jsx(Box, { display: 'flex', gap: 1, children: _jsxs(Typography, { variant: 'caption', color: theme.palette.grey[400], children: [translate('common.processingDocuments'), ":", _jsxs(Typography, { variant: 'caption', color: theme.palette.common.white, children: [' ', processingDocumentCount] })] }) }), _jsx(Box, { display: 'flex', gap: 1, children: _jsxs(Typography, { variant: 'caption', color: theme.palette.grey[400], children: [translate('common.unprocessableDocuments'), ":", _jsxs(Typography, { variant: 'caption', color: theme.palette.common.white, children: ['', " ", unprocessableDocumentCount] })] }) }), _jsx(Box, { display: 'flex', gap: 1, children: _jsxs(Typography, { variant: 'caption', color: theme.palette.grey[400], children: [translate('common.failedDocuments'), ":", _jsxs(Typography, { variant: 'caption', color: theme.palette.common.white, children: ['', " ", failedDocumentCount] })] }) })] }), arrow: true, placement: 'top', slotProps: {
                                                popper: { disablePortal: false }
                                            }, children: _jsx(Typography, { onClick: isXs || isIpadMini || isIpadMiniLandscape
                                                    ? function (e) {
                                                        e.stopPropagation();
                                                        setOpenTooltipDocuments(function (prev) { return (prev === title ? null : title); });
                                                    }
                                                    : undefined, noWrap: true, variant: 'body2', color: 'text.secondary', sx: { cursor: 'pointer' }, children: "".concat(docCount, " ").concat(translate(docCount === 1 ? 'common.document' : 'common.documents')) }) }) })] })] }), _jsx(IconButton, { size: 'small', onClick: handleMenuOpen, children: _jsx(MoreVerticalCircle01Icon, {}) })] }), _jsx(Menu, { anchorEl: anchorEl, open: Boolean(anchorEl), onClose: function (event) {
                    event.stopPropagation();
                    handleMenuClose();
                }, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, transformOrigin: { vertical: 'top', horizontal: 'right' }, onClick: function (event) { return event.stopPropagation(); }, children: menuItems.map(function (menuItem) { return (_jsxs(MenuItem, { divider: menuItem.divider, sx: { color: menuItem.color }, onClick: function () {
                        handleMenuClose();
                        menuItem.onClick();
                    }, disabled: menuItem.disabled, children: [_jsx(ListItemIcon, { children: _jsx(menuItem.icon, { fontSize: 20, color: menuItem.color }) }), _jsx(ListItemText, { children: menuItem.text })] }, menuItem.text)); }) })] }));
};
export default SubFolderCard;
